import React from "react";
import FormComponent from "../FormComponent";

const FormComponentResponse = ({ component, value, onChange, readOnly }) => {
  return <FormComponent component={component} value={value} onChange={onChange} mode="response" readOnly={readOnly} />;
};

export default FormComponentResponse;
